import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';

import chat, { NAME as chatName }
  from 'containers/Chat/State';
import editProfileDetails, { NAME as editProfileDetailsName }
  from 'containers/ProfileInfo/State';
import tippingInfo, { NAME as tippingInfoName }
  from 'containers/ProfileVideo/State';
import accessManagementAdminReducer, { ACCESS_MANAGEMENT_REDUCER_NAME as accessManagementAdmin }
  from 'pages/AdminAccessManagement/redux';
import adminDashboard, { NAME as adminDashboardName }
  from 'pages/AdminDashboard/State';
import administrators, { NAME as administratorsName }
  from 'pages/StudioSettings/ManageAdministrators/State';
import chart, { NAME as chartName }
  from 'pages/Charts/State';
import conversations, { NAME as conversationsName }
  from 'pages/Settings/Inbox/State';
import inboxNew, { NAME as inboxNewName }
  from 'pages/Settings/Inbox-new/State';
import directory, { NAME as directoryName }
  from 'pages/Directory/State';
import drawer, { NAME as drawersName }
  from 'pages/Drawer/State';
import earnings, { NAME as earningsName }
  from 'pages/StudioEarningReports/EarningsReport/State';
import earningsbyday, { NAME as earningsbydayName }
  from 'pages/StudioInsights/DailyRevenuePage/EarningsReportByDay/State';
import achievements, { NAME as itemsAchievements }
  from 'pages/Achievements/State';
import items, { NAME as itemsName }
  from 'pages/ExampleList/State';
import notifications, { NAME as notificationName }
  from 'pages/Notifications/State';
import payment, { NAME as paymentName }
  from 'features/Payment/State';
import payout, { NAME as payoutName }
  from 'features/Payout/State';
import performerDetails, { NAME as performerDetailsName }
  from 'pages/PerformerEditProfile/Insights/State';
import performerShop, { NAME as performerShopName }
  from 'pages/PerformerHub/broadcasterTools/PerformerShop/State';
import performerStudioInfo, { NAME as performerStudioInfoName }
  from 'pages/PerformerEditProfile/State';
import performerStudioProfile, { NAME as performerStudioProfileName }
  from 'pages/PerformerProfile/Store/State';
import profile, { NAME as profileName }
  from 'pages/ProfileV2/State';
import profileBody, { NAME as profileBodyName }
  from 'pages/ProfileV2/ProfileBody/State';
import profileOptions, { NAME as profileOptionsName }
  from 'pages/EditProfileWrapper/State';
import revenueinfo, { NAME as revenueinfoName }
  from 'pages/RevenueInfo/State';
import search, { NAME as searchName }
  from 'pages/Search/State';
import studioRevenue, { NAME as studioRevenueName }
  from 'pages/DashboardPage/State';
import studios, { NAME as studiosName }
  from 'pages/StudioInvitation/State';
import topearners, { NAME as topearnersName }
  from 'pages/StudioEarningReports/TopEarningPerformers/State';
import user, { NAME as userName }
  from 'pages/User/State';
import verification, { NAME as verificationName }
  from 'pages/OwnerVerification/State';
import verificationQueue, { NAME as verificationQueueName }
  from 'pages/StudioVerificationQueue/State';
import { default as earningsByPerformers, NAME as earningsByPerformersName }
  from 'pages/StudioInsights/DetailedRevenuePage/EarningsReportByPerformers/State';
import roster, { NAME as rosterName }
  from 'pages/StudioRoster/State';
import basicInfoDetails, { NAME as basicInfoDetailsName }
  from 'components/BasicInfo/State';
import identityOnboarding, { NAME as identityOnboardingForm }
  from 'components/IdentityForm/State';
import impersonate, { NAME as impersonateName }
  from 'components/Impersonate/State';
import { default as securityQuestions, NAME as securityQuestionsName }
  from 'components/SecurityQuestions/State';

import watchRoomRoster, { NAME as roomRosterWatcherName }
  from '../firebase/firebaseWatchers/RoomRoster';
import firebaseAuth, { NAME as firebaseAuthName }
  from '../firebase/firebaseAuth/State';
import mainChatWatcher, { NAME as mainChatWatcherName }
  from '../firebase/firebaseWatchers/MainChatState';
import privateChatWatcher, { NAME as privateChatWatcherName }
  from '../firebase/firebaseWatchers/PrivateChatState';
import roomStateWatcher, { NAME as roomStateWatcherName }
  from '../firebase/firebaseWatchers/RoomState';

import app, { NAME as appName } from './AppState';


export default combineReducers({
  routing,
  [userName]: user,
  [searchName]: search,
  [itemsName]: items,
  [itemsAchievements]: achievements,
  [notificationName]: notifications,
  [drawersName]: drawer,
  [chartName]: chart,
  [rosterName]: roster,
  [earningsName]: earnings,
  [earningsbydayName]: earningsbyday,
  [earningsByPerformersName]: earningsByPerformers,
  [topearnersName]: topearners,
  [administratorsName]: administrators,
  [verificationQueueName]: verificationQueue,
  [studiosName]: studios,
  [revenueinfoName]: revenueinfo,
  [verificationName]: verification,
  [basicInfoDetailsName]: basicInfoDetails,
  [editProfileDetailsName]: editProfileDetails,
  [securityQuestionsName]: securityQuestions,
  [conversationsName]: conversations,
  [inboxNewName]: inboxNew,
  [performerDetailsName]: performerDetails,
  [performerStudioProfileName]: performerStudioProfile,
  [performerStudioInfoName]: performerStudioInfo,
  [studioRevenueName]: studioRevenue,
  [studioRevenueName]: studioRevenue,
  [profileOptionsName]: profileOptions,
  [directoryName]: directory,
  [paymentName]: payment,
  [payoutName]: payout,
  [profileName]: profile,
  [profileBodyName]: profileBody,
  [appName]: app,
  [firebaseAuthName]: firebaseAuth,
  [roomStateWatcherName]: roomStateWatcher,
  [roomRosterWatcherName]: watchRoomRoster,
  [mainChatWatcherName]: mainChatWatcher,
  [chatName]: chat,
  [adminDashboardName]: adminDashboard,
  [accessManagementAdmin]: accessManagementAdminReducer,
  [tippingInfoName]: tippingInfo,
  [privateChatWatcherName]: privateChatWatcher,
  [identityOnboardingForm]: identityOnboarding,
  [performerShopName]: performerShop,
  [impersonateName]: impersonate,
});
